//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/Validate.js";
import "../no/TaggedObjectCollection.js";
import "../no/BasePart.js";
let d=[[],[[["persistent_result"],"CreateCheckMaximumOverhangAngleBuilder",{R_:{overhang_builder:"Validate.CheckMaximumOverhangAngleBuilder"}},1,0],[["persistent_result"],"CreateCheckMinimumRadiusBuilder",{R_:{minimum_radius_builder:"Validate.CheckMinimumRadiusBuilder"}},1,0],[["persistent_result"],"CreateCheckMinimumWallThicknessBuilder",{R_:{wallthickness_builder:"Validate.CheckMinimumWallThicknessBuilder"}},1,0],[["persistent_result"],"CreateCheckTrappedSupportsBuilder",{R_:{trapped_supports_builder:"Validate.CheckTrappedSupportsBuilder"}},1,0],[["persistent_result"],"CreateCheckModelWithinPrintableVolumeBuilder",{R_:{check_model_within_printable_volume_builder:"Validate.CheckModelWithinPrintableVolumeBuilder"}},1,0],[["persistent_result"],"CreateCheckWhollyEnclosedVolumeBuilder",{R_:{check_wholly_enclosed_volume_builder:"Validate.CheckWhollyEnclosedVolumeBuilder"}},1,0],[["analysisResults"],"EvaluateAll",{},1,0],[["analysisResults"],"DeactivateAll",{},1,0],[["size"],"FindAllAnalysisResults",{R_:{analysisResults:"Validate.AnalysisResult[]"}},0,0],[["sid"],"FindObject",{R_:{analysisResults:"Validate.AnalysisResult"}},1,0],[["persistentResult"],"CreateCheckPrintTimeBuilder",{R_:{partOrientationBuilder:"Validate.CheckPrintTimeBuilder"}},1,0],[["persistentResult"],"CreateCheckOverheatingBuilder",{R_:{overheatingBuilder:"Validate.CheckOverheatingBuilder"}},1,0],[["persistent_result"],"CreateCheckPartOrientationBuilder",{R_:{partorientation_builder:"Validate.CheckPartOrientationBuilder"}},1,0],[["analysisType","size"],"FindAllAnalysisResultsOfType",{R_:{analysisResults:"Validate.AnalysisResult[]"}},1,0],[["persistentResult"],"GetAnalysisResultValue",{R_:{analysisValue:''}},1,0],[["persistent_result"],"CreateCheckPorosityBuilder",{R_:{check_porosity_builder:"Validate.CheckPorosityBuilder"}},1,0],[["persistent_result"],"CreateCheckChannelRatioBuilder",{R_:{channelRatioBuilder:"Validate.CheckChannelRatioBuilder"}},1,0],[["persistentResult"],"CreateCheckThermalDistortionBuilder",{R_:{checkThermalDistortionBuilder:"Validate.CheckThermalDistortionBuilder"}},1,0],[["persistentResult","checkMethod"],"CreateBodyComparisonCheckBuilder",{R_:{bodyComparisonCheckBuilder:"Validate.BodyComparisonCheckBuilder"}},2,0]],[]];
SPLM.Validate.AnalysisResultCollection = class extends SPLM.TaggedObjectCollection{
    constructor (owner){
        if(owner !== undefined){
            if(owner._owner !== undefined){
                super(owner._owner);
                this._owner = owner._owner;
            }
            else{
                super(owner);
                this._owner = owner;
            }
            this._d['ObjectId'] = this._owner._d['ObjectId'];
        }
        else{
            super();
        }
        this._d['Class'] = "SPLM.Validate.AnalysisResultCollection";
        SPLM.c$d(this.Class,d);d=[];
    }
    ToArray(context)
    {
        let r={};
        if(context === undefined){
            r.ToArray={"context":this._d.ObjectId};
        }
        else{
            r.ToArray={"context":context};
        }
        r.Class=this._d.Class;
        if(SPLM.api === undefined){
            this._d.ToArray=r.ToArray;
        }
        else{
            SPLM.api.push(r);
        }
        return r;
    }
};

SPLM.Validate.AnalysisResultCollection.AnalysisResultType = Object.freeze({
    "MaximumOverhangAngle" : "MaximumOverhangAngle", "PrintTime" : "PrintTime", "Overheating" : "Overheating"});

export default SPLM;